export const ar = {
    nav: {
      about: 'من نحن',
      tours: 'السفر',
      realEstate: 'العقارات',
      news: 'الأخبار',
      insights: 'رؤى الاستثمار',
      contact: 'اتصل بنا',
      tourDropdown: {
        dayTours: 'جولات اسطنبول اليومية',
        shoreExcursions: 'رحلات الشاطئ',
        foodTour: 'جولة الطعام',
        reConsulting: 'استشارات عقارية (مجاناً)',
        layoverTour: 'جولة التوقف',
        medicalTourism: 'السياحة العلاجية'
      },
      realEstateDropdown: {
        besiktas: 'بشكتاش',
        florya: 'باكركوي',
        kanalIstanbul: 'قناة اسطنبول',
        skyland: 'ناطحة سحاب كبرى',
        merkezefendi: 'زيتين بورنو',
        tualComfort: 'قناة اسطنبول الثاني',
        referansBeylikduzu: 'شقق فاخرة على الجانب الأوروبي'
      }
    },
    hero: {
      title: 'بوابتك إلى اسطنبول',
      subtitle: 'التميز في الاستثمار والسياحة',
      motto: '"نحن شريكك الموثوق في تركيا"',
      exploreTours: 'استكشف الجولات',
      viewProperties: 'عرض العقارات'
    },
    about: {
      title: 'عن Viaturkey',
      intro: 'Viaturkey هي شركة متكاملة الخدمات مقرها اسطنبول، متخصصة في السياحة والاستشارات والخدمات الاستشارية العقارية داخل وخارج اسطنبول وبقية تركيا.',
      tourism: 'الخدمات السياحية',
      tourismDesc: 'تجارب سياحية شاملة في اسطنبول وتركيا مصممة حسب احتياجاتك.',
      realEstate: 'استشارات عقارية',
      realEstateDesc: 'إرشاد خبير في فرص الاستثمار العقاري التركي.',
      realEstateExtra: 'يمكن أيضاً تقديم خدمات إدارة العقارات عند الطلب وبتوكيل رسمي.',
      residence: 'تصريح الإقامة',
      residenceDesc: 'مساعدة مهنية في طلبات تصريح الإقامة التركية.',
      citizenship: 'الجنسية التركية',
      citizenshipDesc: 'دعم كامل في عملية الحصول على الجنسية التركية.',
      establishBusiness: 'تأسيس الأعمال',
      establishBusinessDesc: 'مساعدة متخصصة في إنشاء وتسجيل أعمالك في تركيا.',
      workPermit: 'الحصول على تصريح العمل',
      workPermitDesc: 'إرشاد شامل بشأن طلبات تصاريح العمل للمواطنين الأجانب في تركيا.',
      founderGreeting: 'مرحباً، أنا الشريك المؤسس لشركة Viaturkey للاستثمارات والسياحة. اسمي أكين غوزيل. أنا رائد أعمال متسلسل في عمليات السياحة والاستشارات العقارية وشريك أعمال محلي موثوق مقره في اسطنبول، تركيا. مع فريقنا من الخبراء على أرض الواقع، نتطلع للتحدث معك بشأن خططك في تركيا.',
      founderName: 'أكين غوزيل',
      founderTitle: 'الشريك المؤسس، Viaturkey للاستثمارات والسياحة'
    },
    interestField: {
      title: 'مجال اهتمامك في تركيا',
      travel: 'سفر Viaturkey',
      travelDesc: 'استكشف اسطنبول مع جولات خاصة ومرشدين محليين خبراء',
      invest: 'استثمار Viaturkey',
      investDesc: 'عقارات فاخرة وفرص استثمارية في اسطنبول',
      news: 'أخبار Viaturkey',
      newsDesc: 'آخر أخبار الحياة والأعمال من تركيا',
      insights: 'رؤى الاستثمار Viaturkey',
      insightsDesc: 'مشاريع إسطنبول الكبرى وبيانات السوق وأرقام السياحة للمستثمرين',
    },
    tours: {
      title: 'الخدمات السياحية',
      subtitle: 'استكشف اسطنبول وتركيا مع مرشدين محليين خبراء',
      whyBookTitle: 'لماذا تحجز معنا؟',
      bestPrice: 'ضمان أفضل سعر – احجز مباشرة ووفّر',
      bestPriceDesc: 'بالتواصل معنا مباشرة عبر موقعنا أو البريد الإلكتروني، تتجاوز المنصات الوسيطة مثل TripAdvisor / Viator / Get Your Guide التي تفرض عمولات تصل إلى 25%. نفضل تمرير هذه المدخرات إليك كخصم حجز مباشر.',
      tailorMade: 'برامج مخصصة',
      tailorMadeDesc: 'رحلتك لا ينبغي أن تكون نمطية. سواء كان لديك موقع تاريخي محدد في ذهنك أو جوهرة مخفية كنت تحلم بها، نحن متخصصون في تخصيص كل التفاصيل لتناسب اهتماماتك الشخصية.',
      expertGuides: 'مرشدون محليون خبراء',
      expertGuidesDesc: 'مرشدونا الأكثر شعبية غالباً ما يكون الطلب عليهم مرتفعاً وجداولهم تمتلئ بسرعة. الحجز المسبق يضمن لك تاريخك ووقتك المفضل مع محترف من الدرجة الأولى.',
      transparency: 'شفافية تامة',
      transparencyDesc: 'لا رسوم خفية أو مفاجآت. نقدم تفاصيل واضحة عن برنامجك ومدته وما هو مشمول بالضبط. ستعرف دائماً الشروط وسياسة الإلغاء قبل أن تبدأ مغامرتك.',
      duration: 'المدة',
      highlights: 'أبرز المعالم',
      included: 'مشمول',
      excluded: 'غير مشمول',
      contactPrice: 'تواصل للحصول على أفضل سعر',
      inquireNow: 'استفسر الآن',
      alsoAvailable: 'متاح أيضاً',
      flexibleToursIntro: 'يمكن أيضاً تنظيم جولات التراث المسيحي وجولات الآثار وجولات التسوق بجدول مرن حسب وتيرتك ووفقاً لخطتك.',
      flexibleToursContact: 'يرجى التواصل للحصول على التفاصيل',
      christianHeritage: 'جولات التراث المسيحي',
      archaeologyTours: 'جولات الآثار',
      shoppingTours: 'جولات التسوق',
      pricingBanner: 'إرشاد ثقافي خاص - إدارة الجولات بدءاً من 160 دولار للمجموعة من 2 إلى 8 أشخاص.',
      pricingSolo: 'يرجى طلب عرض أسعار للمسافرين المنفردين أو مجموعات FIT / الحوافز.',
      priceFrom200: 'بدءاً من 200 دولار أمريكي',
      priceFrom150: 'بدءاً من 150 دولار أمريكي للشخص',
      priceFrom175: 'بدءاً من 175 دولار للمجموعة',
      priceFrom160: 'بدءاً من 160 دولار للمجموعة',
      priceFrom185: 'بدءاً من 185 دولار للمجموعة',
      contactWhatsApp: 'تواصل عبر واتساب',
      commissionWarning: {
        title: 'إشعار مهم',
        message: 'يرجى العلم أن هذه المواقع الثلاثة تأخذ عمولة 25% عن كل شخص من خدمة الجولة السياحية، حيث أنك تدفع المال لطرف ثالث لا يشارك في أي من العمليات الحقيقية أو الخبرة أو الجهود على الإطلاق!',
        directMessage: 'عند الحجز مباشرة معنا، تذهب أموالك مباشرة إلى مزود الخدمة الفعلي — بدون وسيط وبدون رسوم مخفية.'
      },
      businessDining: {
        tip: 'نصائح للمسافرين رجال الأعمال في اسطنبول',
        title: 'أفضل أماكن تناول الطعام في اسطنبول لاجتماعات العمل',
        specialty: 'التخصص',
        steakhouseTitle: 'مطاعم الستيك والكباب المميزة',
        seafoodTitle: 'مطاعم المأكولات البحرية على البوسفور والواجهة البحرية',
        italianTitle: 'المطبخ العالمي والإيطالي الراقي',
        fineDiningTitle: 'مطاعم فاخرة مع إطلالات بانورامية'
      },
      videoSection: {
        title: 'استكشف اسطنبول معنا',
        desc: 'انضم إلى جولتنا المصحوبة بمرشدين عبر أبرز معالم اسطنبول — المسجد الأزرق الرائع وآيا صوفيا التاريخية. اكتشف التاريخ الغني والهندسة المعمارية المذهلة والتراث الثقافي.'
      },
      realEstateConsulting: {
        title: 'خدمة استشارات عقارية',
        vanInfo: 'يمكن ترتيب سيارة خاصة مع سائق بتكلفة إضافية.',
        consultingInfo: 'يتم تقديم 3-5 ساعات كحد أدنى من الاستشارات العقارية المجانية.',
        description: 'يمكن تقديم هذه الخدمة للضيوف (بطلب خاص) الذين يرغبون في الحصول على أكثر فكرة تفصيلية عن سوق العقارات والاستثمار في اسطنبول.',
        ctaText: 'حدد موعد مكالمة 15 دقيقة للحديث عن خططك الاستثمارية في تركيا'
      },
      includedItems: [
        'مرشد سياحي خاص ومخصص',
        'دخول سريع لجميع المتاحف (باستثناء آيا صوفيا)',
        'مرشد ذو معرفة أكاديمية',
        'مدة الجولة 5-8 ساعات',
        'الاستقبال من الفندق مع/بدون سيارة مكيفة'
      ],
      excludedItems: [
        'إكراميات المرشد',
        'رسوم دخول جميع المتاحف',
        'الغداء',
        'جميع أنواع النفقات خلال الجولة'
      ],
      tourDetails: {
        '1': {
          name: 'جولة يومية في المدينة القديمة باسطنبول',
          description: 'استكشف القلب التاريخي لاسطنبول مع زيارة المعالم الشهيرة. مدة لا تقل عن 5-8 ساعات مع مرشدك المحلي الخبير الذي يروي لك التاريخ بالقصص والتقاليد والحكايات الحقيقية.',
          duration: '5-8 ساعات كحد أدنى',
          highlights: ['آيا صوفيا', 'الجامع الأزرق', 'قصر توبكابي', 'البازار الكبير', 'ميدان سباق الخيل'],
          whatsappMsg: 'مرحباً، أنا مهتم بجولة المدينة القديمة اليومية في اسطنبول. هل يمكنكم تزويدي بمزيد من التفاصيل؟'
        },
        '2': {
          name: 'رحلات الشاطئ - جولة في المدينة القديمة باسطنبول',
          description: 'مثالية لركاب الرحلات البحرية! جولة شاملة في المدينة القديمة باسطنبول مع خدمة النقل من وإلى الميناء. مدة لا تقل عن 5-8 ساعات مع مرشدك المحلي الخبير.',
          duration: '5-8 ساعات كحد أدنى',
          highlights: ['الاستقبال من الميناء', 'معالم المدينة القديمة', 'العودة إلى الميناء'],
          whatsappMsg: 'مرحباً، أنا مهتم برحلات الشاطئ. هل يمكنكم تزويدي بمزيد من التفاصيل؟'
        },
        '3': {
          name: 'جولات أثناء التوقف من مطاري اسطنبول / صبيحة كوكجن',
          description: 'استغل وقت التوقف بأفضل طريقة! جولات مخصصة من مطار اسطنبول ومطار صبيحة كوكجن.',
          duration: '4-8 ساعات (مرن)',
          highlights: ['الاستقبال والتوصيل من/إلى المطار', 'برنامج مرن', 'المعالم الرئيسية', 'وقت للتسوق'],
          whatsappMsg: 'مرحباً، أنا مهتم بجولة أثناء التوقف في اسطنبول. إليكم تفاصيل رحلتي:\nرقم رحلة الوصول: \nرقم رحلة المغادرة: \nمدة التوقف: \nالوقت المتاح للجولة: تقريباً ___ ساعات\nعدد الأشخاص: ',
          details: 'يرجى إبلاغنا بتفاصيل رحلتك إلى اسطنبول والتفاصيل الأخرى ذات الصلة:\n\nتفاصيل الوصول والرحلة:\n• رقم رحلة الوصول: ............\n• رقم رحلة المغادرة: ............\n• مدة التوقف: ............\n• الوقت المتاح للجولة: تقريباً ......... ساعات\n\nخيار الجولة: جولة يوم كامل أثناء التوقف (خاصة)\nمقدمة مريحة ومسترخية لاسطنبول مع مرشد محلي، مثالية للزوار لأول مرة.\n\nالبرنامج المقترح:\n• الاستقبال من المطار بعد مراقبة الجوازات\n• الانتقال إلى السلطان أحمد (المدينة القديمة)\n• زيارة الجامع الأزرق وآيا صوفيا وميدان سباق الخيل\n• التوقف عند بازار أراستا أو سوق التوابل\n• رحلة بالعبّارة عبر البوسفور إلى الجانب الآسيوي (اختياري وحسب الوقت المتاح)\n• عشاء تركي (على حسابك) أو تذوق أطعمة الشارع المحلية\n• الانتقال مرة أخرى إلى المطار'
        },
        '4': {
          name: 'جولة الطعام في اسطنبول - مذاق قارتين',
          description: 'رحلة طهوية عبر الجانبين الأوروبي والآسيوي لاسطنبول. استمتع بالمطبخ التركي الأصيل والنكهات المحلية.',
          duration: '5-6 ساعات',
          highlights: ['فطور تركي تقليدي', 'طعام الشارع', 'الأسواق المحلية', 'عبور البوسفور', 'الحلويات'],
          whatsappMsg: 'مرحباً، أنا مهتم بجولة الطعام في اسطنبول. هل يمكنكم تزويدي بمزيد من التفاصيل؟'
        },
        '5': {
          name: 'خدمات النقل من مطاري اسطنبول / صبيحة كوكجن',
          description: 'خدمات نقل مريحة وموثوقة من المطار. سيارات خاصة مع سائقين محترفين.',
          duration: 'حسب الحاجة',
          highlights: ['خدمة من الباب إلى الباب', 'سائقون محترفون', 'سيارات حديثة', 'متاح على مدار الساعة', 'تتبع الرحلات'],
          whatsappMsg: 'مرحباً، أنا مهتم بخدمات النقل من المطار. هل يمكنكم تقديم عرض سعر؟',
          includedItems: [
            'الاستقبال والترحيب في المطار',
            'خدمة من الباب إلى الباب',
            'سائقون محترفون',
            'سيارات حديثة مكيفة - مشروبات باردة في السيارة',
            'متاح على مدار الساعة',
            'تتبع الرحلات الجوية'
          ],
          excludedItems: [
            'أسعار تبدأ من 1-4 ركاب',
            'أسعار لـ 5-10 ركاب',
            'أسعار لـ 11 وأكثر',
            'يرجى التواصل معنا للحصول على عرض سعر'
          ]
        }
      }
    },
    realEstate: {
      title: 'فرص الاستثمار',
      titleHighlight1: 'فرص',
      titleHighlight2: 'الاستثمار',
      downloadBrochure: 'تحميل الكتيب',
      requestInfo: 'طلب معلومات',
      discoveryCall: 'احجز مكالمة استكشافية مدتها 15 دقيقة لمناقشة أهدافك الاستثمارية في اسطنبول وتركيا.',
      moreProjects: 'المزيد من المشاريع قريباً...',
      officialResources: 'الموارد الاستثمارية الرسمية',
      acquiringPropertyTitle: 'شراء عقار والحصول على الجنسية في تركيا',
      acquiringPropertyDesc: 'دليل رسمي حول الإجراءات والوثائق والمبادئ التوجيهية للمواطنين الأجانب لشراء العقارات والحصول على الجنسية.',
      citizenshipGuideTitle: 'دليل حصول المواطنين الأجانب على الجنسية التركية',
      citizenshipGuideDesc: 'دليل PDF رسمي شامل من مكتب الاستثمار التابع لرئاسة الجمهورية التركية.',
      residencePermitTitle: 'الحصول على تصريح إقامة',
      residencePermitDesc: 'الإجراءات والوثائق المطلوبة للمواطنين الأجانب للحصول على تصاريح الإقامة في تركيا.',
      establishBusinessTitle: 'تأسيس شركة',
      establishBusinessDesc: 'معلومات عن بدء وتسجيل شركة في تركيا، بما في ذلك الأنواع وعملية التأسيس.',
      workPermitTitle: 'الحصول على تصريح عمل',
      workPermitDesc: 'إرشادات للمواطنين الأجانب حول الحصول على تصاريح العمل للعمل بشكل قانوني في تركيا.',
      developer: 'المطور',
      status: 'الحالة',
      apartmentTypes: 'أنواع الشقق',
      keyFeatures: 'الميزات الرئيسية',
      projectDetails: {
        'besiktas-luxury': {
          name: 'مشروع سكني فاخر في بشكتاش',
          location: 'شيشلي - مجيدية كوي، اسطنبول',
          description: 'مشروع سكني فاخر يجمع بين النسيج التاريخي لاسطنبول والحياة العصرية، يقدم أسلوب حياة حصري مع إطلالة على البوسفور. من تطوير Premium Developer.',
          highlights: ['175 شقة على 6 طوابق', 'إطلالات على البوسفور والمناظر الطبيعية والمدينة', 'مسبح داخلي وصالة رياضية وسبا', 'أمن على مدار الساعة وموقف سيارات مغطى', 'على مسافة قريبة من المترو والعبّارة', 'مؤهل للجنسية التركية', 'مؤهل لتصريح الإقامة']
        },
        'nivak-florya': {
          name: 'شقق فاخرة للغاية في قلب حي باكركوي',
          location: 'باكركوي، اسطنبول',
          description: 'أسلوب حياة على المستوى الذي تستحقه حقاً. مجتمع خاص وبوتيكي بتصميم معماري مستوحى من الطبيعة وبحيرة صناعية ومناظر طبيعية خضراء فريدة.',
          highlights: ['96 وحدة حصرية فقط', 'ارتفاع السقف يتجاوز 3.20 متر', 'على بعد خطوات من الساحل ومنتزه البحر', 'بجوار حديقة أتاتورك', 'مسبح داخلي وحمام تركي وساونا', 'مركز لياقة واستوديو بيلاتس', 'ملاعب كرة قدم وسلة', 'مؤهل للجنسية التركية', 'جاهز للتسليم - يونيو 2025']
        },
        'tual-golyaka-kanal': {
          name: 'مشروع شقق قناة اسطنبول',
          location: 'الجانب الأوروبي من اسطنبول',
          description: 'مشروع سكني منخفض الكثافة يجمع بين الحياة الحضرية العصرية والتصميم المستوحى من الطبيعة. يقع بالقرب من ممر قناة اسطنبول.',
          highlights: ['26,000 متر مربع - 70% مساحات خضراء', 'عمارة أفقية منخفضة الارتفاع', 'قريب من بحيرة كوتشوك تشكمجة', 'وصول سهل إلى طريق TEM السريع', 'مسبح خارجي ومركز لياقة', 'مسارات للمشي والركض', 'حدائق خاصة وشرفات كبيرة', 'أمن على مدار الساعة', 'مؤهل للجنسية التركية', 'بالقرب من ممر قناة اسطنبول']
        },
        'alya-merkezefendi': {
          name: 'مشروع جديد في موقع مركزي جداً بالقرب من حي الفاتح',
          location: 'زيتين بورنو، اسطنبول',
          description: 'مجمع سكني حديث في قلب زيتين بورنو يوفر حياة حضرية مريحة مع وصلات نقل ممتازة. يضم 467 شقة على 6 طوابق.',
          highlights: ['467 شقة و15 وحدة تجارية', 'مساحة أرض 17,928 متر مربع', 'مسبح داخلي وصالة رياضية', 'ملاعب كرة سلة وكرة قدم', 'حمام تركي وساونا وغرفة بخار', 'ملاعب أطفال ومسارات للمشي', 'أمن على مدار الساعة وموقف مغطى', '650 متر إلى محطة المتروبوس', 'مؤهل للجنسية التركية', 'مؤهل لتصريح الإقامة']
        },
        'skyland-prime': {
          name: 'برج شيشلي ميجر برايم السكني',
          location: 'شيشلي - ماسلاك، اسطنبول',
          description: 'أطول مجمع مباني في تركيا، يقع بين ليفنت وماسلاك. من تصميم المهندس المعماري بيتر فوغان من برودواي ماليان.',
          highlights: ['أطول مجمع في تركيا - 1,450 وحدة', 'مساحة بناء 46,000 متر مربع', 'موقع مركزي بين ليفنت وماسلاك', 'لوبي VIP ونظام المنزل الذكي', 'مسابح داخلية وخارجية', 'مركز تسوق وفود كورت وصالة رياضية', 'حمام تركي وساونا وغرفة بيلاتس', 'أمن على مدار الساعة وخدمة نقل ومواقف', 'مدخل خاص من طريق TEM', 'إطلالة على الغابة والمدينة - تسليم فوري', 'مؤهل للجنسية التركية']
        }
      }
    },
    investmentInsights: {
      title: 'رؤى الاستثمار: مشاريع إسطنبول الكبرى وآفاق السوق',
      marketNews: 'أخبار السوق والسياحة',
    },
    news: {
      title: 'أخبار الحياة والأعمال في تركيا',
      tourismRevenue: {
        title: 'تركيا تتجاوز هدف إيرادات السياحة لعام 2025 والوصول القياسي للأجانب',
        desc: '65.2 مليار دولار إيرادات سياحية مع 64 مليون سائح في 2025 — كلا الرقمين أرقام قياسية تاريخية.'
      },
      realEstateMarket: {
        title: 'سوق العقارات في تركيا — قوة أوروبية',
        desc: 'تركيا واحدة من أكثر أسواق العقارات الواعدة في أوروبا. تقع استراتيجياً عند مفترق طرق أوروبا والشرق الأوسط وآسيا الوسطى، وتضم 85 مليون نسمة. بلغت تدفقات الاستثمار الأجنبي المباشر 11.3 مليار دولار، منها 2.8 مليار في العقارات (25% من إجمالي الاستثمار في 2024).',
        cta: 'لمزيد من المعلومات اضغط هنا'
      },
      tourismRecord: {
        title: 'تركيا تسجل أرقاماً قياسية في إيرادات السياحة رغم التحديات الجيوسياسية',
        desc: '64 مليون سائح و65.2 مليار دولار إيرادات في 2025 — تركيا تصبح رابع أكثر دولة زيارة في العالم.'
      }
    },
    kanalIstanbul: {
      sectionTitle: 'مشروع قناة اسطنبول',
      projectPurpose: 'قناة اسطنبول - هدف المشروع',
      projectPurposeDesc: 'تعرّف على الغرض والرؤية وراء مشروع قناة اسطنبول العملاق، الممر المائي البديل للبوسفور.',
      videos: 'قناة اسطنبول - فيديوهات ووثائقيات',
      videosDesc: 'شاهد الفيديوهات الرسمية والوثائقيات حول تطورات مشروع قناة اسطنبول.',
      arabicVideoTitle: 'قناة اسطنبول - فيلم وثائقي بالعربية',
      arabicVideoDesc: 'شاهد الفيلم الوثائقي عن مشروع قناة اسطنبول باللغة العربية.'
    },
    tersaneIstanbul: {
      sectionTitle: 'ترسانة اسطنبول',
      description: 'ترسانة اسطنبول هي مشروع تحول حضري مذهل يحوّل أكبر موقع تراث صناعي في تركيا إلى حي ساحلي عصري ووجهة عالمية المستوى. يرتفع المشروع على موقع ترسانة عامرة التاريخي على الشاطئ الشمالي للقرن الذهبي، ويضفي حياة جديدة على الساحل التاريخي بفنادق خمس نجوم ومتاجر ومساحات اجتماعية ومتاحف ومراكز ثقافية وسكن ومراسٍ وممشى ساحلي يمتد لنحو كيلومترين.',
      ourStory: 'Aliée اسطنبول - قصتنا',
      ourStoryDesc: 'اكتشف الرحلة من حوض بناء السفن العثماني التاريخي إلى وجهة عالمية راقية على القرن الذهبي.',
      thingsToDo: 'Aliée اسطنبول - أنشطة وتجارب',
      thingsToDoDesc: 'استكشف تجارب فاخرة — الإبحار في البوسفور، استوديوهات فنية، برانش الأحد، البيوهاكينغ، وفن الإبرو.'
    },
    goturkiyeBlog: {
      intro: 'كل شيء عن تركيا..',
      readMore: 'اقرأ المقال',
      blogTitles: [
        'تأشيرة البدو الرقمي — تركيا 2026',
        '10 طرق للتحية والوداع',
        '10 أفضل هدايا تذكارية من اسطنبول',
        '10 أطعمة شارع مميزة في تركيا',
        '10 أشهر البهارات في المطبخ التركي',
        '10 أشياء يجب فعلها في اسطنبول',
        '10 حلويات تركية يجب تجربتها',
        '10 هدايا تركية من المتاجر الحرفية',
        '16 طعاماً يجب تجربته في تركيا',
        '13 شيئاً ستفهمه فقط إذا زرت تركيا'
      ]
    },
    digitalNomad: {
      cta: 'للحصول على أحدث المعلومات وأكثرها موثوقية، يرجى زيارة الرابط'
    },
    tags: {
      title: 'علاماتنا'
    },
    newsletter: {
      title: 'النشرة الإخبارية',
      description: 'ابقَ على اطلاع بأحدث الأخبار والجولات وفرص الاستثمار في تركيا.',
      emailPlaceholder: 'بريدك الإلكتروني',
      signUp: 'اشترك',
      subscribing: 'جاري الاشتراك...',
      success: 'تم الاشتراك في النشرة الإخبارية بنجاح!',
      invalidEmail: 'يرجى إدخال عنوان بريد إلكتروني صالح.',
      error: 'خطأ في الاشتراك. يرجى المحاولة مرة أخرى.'
    },
    faq: {
      title: 'الأسئلة الشائعة',
      q1: 'ما هي أفضل شركة جولات خاصة في اسطنبول؟',
      a1: 'فياتركي للاستثمار والسياحة هي شركة جولات خاصة رائدة في اسطنبول تقدم جولات مخصصة بالإنجليزية والروسية والعربية والتركية. نقدم جولات المدينة القديمة، رحلات البوسفور، جولات الطعام، والجولات الشاطئية. احجز مباشرة بدون وسيط.',
      q2: 'كيف يمكنني الحصول على الجنسية التركية عن طريق الاستثمار؟',
      a2: 'يمكنك الحصول على الجنسية التركية بشراء عقار بقيمة 400,000 دولار على الأقل. توفر فياتركي استشارات متخصصة طوال العملية بالكامل من اختيار العقار إلى تقديم طلب الجنسية.',
      q3: 'ما هي أفضل جولات اسطنبول لركاب السفن السياحية؟',
      a3: 'تقدم فياتركي جولات شاطئية خاصة لركاب السفن السياحية تشمل آيا صوفيا والمسجد الأزرق وقصر توبكابي والبازار الكبير. المدة 5-8 ساعات. وفر 25% مقارنة بالمنصات الأخرى.',
      q4: 'أين أفضل أماكن اجتماعات العمل في اسطنبول؟',
      a4: 'أفضل مطاعم اسطنبول لاجتماعات العمل: نصرت ستيك هاوس، بيبر مون، سيبرياني، أولوس 29 (إطلالة بانورامية على البوسفور)، صنسيت جريل آند بار، ولا بيتيت ميزون.',
      q5: 'هل الاستثمار في عقارات اسطنبول آمن؟',
      a5: 'نعم، عقارات اسطنبول استثمار قوي مع قيم متزايدة. تركيا تقدم الجنسية عبر الاستثمار وتصاريح الإقامة. تتعاون فياتركي مع مطورين كبار وتوفر مشاريع في أفضل المواقع.'
    },
    projects: {
      'besiktas-luxury': {
        name: 'مشروع سكني فاخر في بشكتاش',
        location: 'شيشلي - مجيدية كوي، اسطنبول',
        description: 'مشروع سكني فاخر يجمع بين النسيج التاريخي لإسطنبول والحياة العصرية، مع إطلالة على البوسفور. من تطوير Premium Developer.',
        highlights: ['175 شقة على 6 طوابق', 'إطلالة على البوسفور والمدينة', 'مسبح داخلي، صالة رياضية، سبا', 'حراسة 24/7، موقف سيارات داخلي', 'على مسافة مشي من المترو والعبّارة', 'مؤهل للحصول على الجنسية التركية', 'مؤهل لتصريح الإقامة'],
        apartmentTypes: 'من 1+1 إلى 6.5+1', developer: 'Premium Developer', completionStatus: 'مكتمل بنسبة 90%', pricing: 'اتصل للتسعير'
      },
      'nivak-florya': {
        name: 'شقق فاخرة للغاية في قلب حي باكركوي',
        location: 'باكركوي، اسطنبول',
        description: 'أسلوب حياة على المستوى الذي تستحقه. مجتمع خاص وبوتيكي بهندسة معمارية مستوحاة من الطبيعة وبحيرة صناعية ومناظر خضراء فريدة.',
        highlights: ['96 وحدة حصرية فقط', 'ارتفاع السقف أكثر من 3.20 متر', 'خطوات من الساحل والحديقة البحرية', 'مجاور لحديقة أتاتورك', 'مسبح داخلي، حمام تركي، ساونا', 'صالة رياضية واستديو بيلاتس', 'ملاعب كرة قدم وسلة', 'مؤهل للحصول على الجنسية التركية', 'جاهز للتسليم - يونيو 2025'],
        apartmentTypes: '3 غرف نوم (225 م²)، فلل 4-5 غرف، بنتهاوس 6-7 غرف', developer: 'Premium Developer', completionStatus: 'جاهز للتسليم', pricing: 'اتصل للتسعير'
      },
      'tual-golyaka-kanal': {
        name: 'مشروع شقق قناة اسطنبول',
        location: 'الجانب الأوروبي من اسطنبول',
        description: 'مشروع سكني منخفض الكثافة يجمع بين المعيشة الحضرية والتصميم المستوحى من الطبيعة. بالقرب من ممر قناة اسطنبول مع إمكانية نمو عالية.',
        highlights: ['26,000 م² — 70% مساحات خضراء', 'هندسة أفقية منخفضة الارتفاع', 'قريب من بحيرة كوتشوك تشكمجة', 'سهولة الوصول لطريق TEM', 'مسبح خارجي وصالة رياضية', 'ممرات للمشي والجري', 'حدائق خاصة وتراسات كبيرة', 'حراسة 24/7', 'مؤهل للحصول على الجنسية التركية', 'قريب من ممر قناة اسطنبول'],
        apartmentTypes: 'من 2+1 إلى 5+1، فلل مستقلة', developer: 'Premium Developer', completionStatus: 'مراحل متعددة قيد التطوير', pricing: 'اتصل للتسعير'
      },
      'alya-merkezefendi': {
        name: 'مشروع جديد في موقع مركزي جداً بالقرب من حي الفاتح',
        location: 'زيتين بورنو، اسطنبول',
        description: 'مجمع سكني حديث في قلب زيتين بورنو يوفر حياة حضرية مريحة مع اتصالات نقل ممتازة.',
        highlights: ['467 شقة و15 وحدة تجارية', '17,928 م² أرض، 80,124 م² بناء', 'مسبح داخلي، صالة رياضية', 'ملاعب كرة سلة وقدم', 'حمام تركي، ساونا، غرفة بخار', 'ملاعب أطفال وممرات مشي', 'حراسة 24/7، موقف داخلي', '650 م إلى محطة جفيزلي باغ', 'مؤهل للحصول على الجنسية التركية', 'مؤهل لتصريح الإقامة'],
        apartmentTypes: '1+1، 2+1، 3+1، 4+1، دوبلكس', developer: 'Premium Developer', completionStatus: 'قيد الإنشاء', pricing: 'اتصل للتسعير'
      },
      'skyland-prime': {
        name: 'برج شيشلي ميجر برايم السكني',
        location: 'شيشلي - ماسلاك، اسطنبول',
        description: 'أطول مجمع أبنية في تركيا، يقع بين ليفنت وماسلاك. من تصميم المهندس بيتر فون من برودواي مالان.',
        highlights: ['أطول مجمع في تركيا — 1,450 وحدة', '46,000 م² مساحة بناء', 'موقع مركزي بين ليفنت وماسلاك', 'لوبي VIP ونظام منزل ذكي', 'مسابح داخلية وخارجية', 'مركز تسوق، فود كورت، صالة رياضية', 'حمام تركي، ساونا، بيلاتس', 'حراسة 24/7، خدمة نقل، مواقف', 'مدخل خاص من طريق TEM', 'إطلالة على الغابة والمدينة — تسليم فوري', 'مؤهل للحصول على الجنسية التركية'],
        apartmentTypes: 'وحدات سكنية ومكتبية', developer: 'Premium Developer', completionStatus: 'تسليم فوري', pricing: 'اتصل للتسعير'
      },
      'tual-comfort-kanal-2': {
        name: 'مشروع شقق قناة اسطنبول الثاني',
        location: 'الجانب الأوروبي من اسطنبول',
        description: 'فرصة استثمارية كبرى على مساحة 24,000 متر مربع في باهتشه شهير مع 60% مساحات خضراء. يقع عند تقاطع مطار اسطنبول الجديد وممر قناة اسطنبول والطريق السريع شمال مرمرة. كل شقة بشرفة. الطابو جاهز.',
        highlights: [
          '480 شقة في 6 أبنية + 20 وحدة تجارية',
          '24,000 متر مربع — 60% مساحات خضراء',
          'إطلالة على بحيرة كوتشوك تشكمجة',
          'كل شقة بشرفة',
          'مسبح داخلي، ساونا وسبا، حمام بخار',
          'صالة رياضية، ملعب كرة سلة، ملعب أطفال',
          'ممرات للمشي ومناطق جلوس عائلية',
          'حراسة 24/7 مع كاميرات مراقبة ونظام أمان إلكتروني',
          '22 كم إلى مطار اسطنبول الجديد',
          '4 كم إلى بحيرة كوتشوك تشكمجة، 3 كم إلى طريق E80',
          'بالقرب من ممر قناة اسطنبول — إمكانية نمو عالية',
          'الطابو جاهز — تم التسليم مارس 2025',
          'مؤهل للحصول على الجنسية التركية'
        ],
        apartmentTypes: '2+1 (104-130 م²)، 3+1 (163-172 م²)',
        developer: 'Premium Developer',
        completionStatus: 'تم التسليم — الطابو جاهز',
        pricing: 'اتصل للتسعير'
      },
      'avrupa-gunesli': {
        name: 'مساكن المترو في وسط إسطنبول 2026',
        location: 'وسط إسطنبول — قرب خطوط المترو الرئيسية',
        description: 'أحدث مشروع سكني رئيسي لعام 2026 من مطوّر مميّز في قلب إسطنبول، على بُعد دقائق من خطوط المترو الرئيسية على المحور التجاري والاستثماري الأهم في المدينة.',
        highlights: [
          'مناطق عافية منفصلة لكبار الزوار للرجال والنساء (نحو 1,500 م²)',
          '1,556 شقة و24 وحدة تجارية ضمن 11 برجاً',
          'تصاميم من 1+1 إلى 4+1 مع خيارات بإطلالة بانورامية أو على الحديقة',
          'منطقة خضراء مركزية مع بركة مائية عاكسة',
          'مسابح داخلية، صالة رياضية، ساونا، حمّام تركي، واستوديو بيلاتس',
          'ملاعب كرة سلة، وملعب كرة قدم، ومنطقة ملاكمة',
          'ملاعب أطفال وأمن تحت مراقبة الكاميرات على مدار الساعة',
          '5 دقائق إلى مترو إكيتيللي–أتاكوي، و5–10 دقائق إلى طريقي E5 وTEM',
          'التسليم: يوليو 2027',
          'مؤهّل للجنسية التركية (عند شراء عدة وحدات)'
        ],
        apartmentTypes: '1+1, 2+1, 3+1, 4+1',
        developer: 'Premium Developer',
        completionStatus: 'قيد الإنشاء — التسليم في يوليو 2027'
      },
      'referans-beylikduzu': {
        name: 'شقق فاخرة على الجانب الأوروبي',
        location: 'الجانب الأوروبي من اسطنبول',
        description: 'مشروع سكني عائلي هادئ على مساحة 31,000 متر مربع مع 70% مساحات خضراء. 709 وحدة سكنية بتصميم فريد للمناظر الطبيعية وإطلالات على المدينة والبحر، مع إمكانية الوصول سيراً على الأقدام إلى أكثر من 300 متجر ومركز تسوق ومستشفى ومارينا غرب اسطنبول.',
        developer: 'Premium Developer',
        completionStatus: 'قيد الإنشاء',
        apartmentTypes: '2+1، 2+1 دوبلكس، 3+1، 3.5+1، 3+1 دوبلكس، 4+1، 4.5+1، 4+1 دوبلكس، 5+1',
        highlights: [
          '709 وحدة على 31,000 متر مربع — 70% مساحات خضراء',
          'إطلالات على المدينة والبحر والمناظر الطبيعية',
          'مسابح خارجية وداخلية',
          'حديقة زن وحديقة لافندر وزيتون',
          'ساونا وحمام تركي ومركز لياقة',
          'ملعب كرة سلة وملعب أطفال وحضانة',
          'على بُعد خطوات من 300+ متجر ومركز تسوق ومستشفى',
          'نظام أمن على مدار الساعة',
          '30 كم إلى مطار اسطنبول (45 دقيقة)',
          '5 كم إلى المتروبوس والطريق السريع E-5',
          'مؤهل للجنسية التركية',
          'مؤهل لتصريح الإقامة'
        ]
      }
    },
    medicalTourism: {
      title: 'السياحة العلاجية في تركيا',
      subtitle: 'رعاية صحية عالمية بأسعار تنافسية — طب الأسنان، زراعة الشعر والجراحة التجميلية',
      intro: 'تركيا من أبرز وجهات السياحة العلاجية بسوق يقدر بـ 4.2-4.6 مليار دولار في 2026. اسطنبول تقدم مستشفيات معتمدة دولياً وأطباء ذوي خبرة عالية.',
      hairTitle: 'الأسئلة الشائعة عن زراعة الشعر',
      h1q: 'طريقة DHI أم FUE — أيهما أفضل؟',
      h1a: 'كلتا الطريقتين تهدفان لنمو دائم للشعر. DHI أسرع تعافياً وأقل نزيفاً. FUE تغطي مساحات أكبر.',
      h2q: 'كم عدد البصيلات المزروعة؟',
      h2a: 'تحتوي كل بصيلة على 2-3 شعرات. يُحدد العدد خلال الاستشارة.',
      h3q: 'هل يمكن للنساء إجراء زراعة الشعر؟',
      h3a: 'نعم، تقنية FUE لا تترك ندوباً مرئية.',
      h4q: 'الآثار الجانبية ومتى يمكن صبغ الشعر؟',
      h4a: 'قد يحدث تورم مؤقت وتنميل. يُنصح بالانتظار 8-12 شهراً قبل الصبغ.',
      cosmeticTitle: 'الأسئلة الشائعة عن الجراحة التجميلية',
      c1q: 'هل فيلر الأنف دائم؟',
      c1a: 'فيلر الهيالورونيك يدوم 6-12 شهراً. حقن الدهون تدوم 3-5 سنوات.',
      c2q: 'هل يمكن تكرار عملية Fox Eye؟',
      c2a: 'نعم، تستخدم خيوط قابلة للذوبان.',
      c3q: 'هل الفرنش ليفت يوقف الشيخوخة؟',
      c3a: 'لا، لكنه يزيل علامات الشيخوخة ويحفز إنتاج الكولاجين.',
      c4q: 'هل فيلر عظام الخد دائم؟',
      c4a: 'الهيالورونيك 6-12 شهراً، حقن الدهون 2-3 سنوات.',
      healthTurkiye: 'خطط لعلاجك عبر بوابة HealthTürkiye الرسمية',
      citation: 'المصدر: HealthTürkiye (healthturkiye.gov.tr). بيانات السوق: تحليل 2026.'
    },
    stats: {
      title: 'اسطنبول: حقائق وأرقام رئيسية',
      titleCity: 'اسطنبول',
      titleFacts: 'حقائق وأرقام رئيسية',
      tourists: 'سائح دولي يزورون اسطنبول سنوياً',
      citizenship: 'الحد الأدنى للاستثمار للحصول على الجنسية التركية',
      residence: 'الحد الأدنى لتصريح الإقامة التركية',
      languages: 'اللغات: الإنجليزية، الروسية، العربية، التركية',
      savings: 'توفير عند الحجز مباشرة مع فياتركي',
      citation: 'وفقاً لفياتركي للاستثمار والسياحة، أبرز منظم رحلات ومستشار عقاري في اسطنبول يخدم العملاء بأربع لغات.'
    },
    map: {
      title: 'زوروا مكتبنا',
      openInMaps: 'فتح في خرائط جوجل'
    },
    contact: {
      title: 'اتصل بنا',
      getInTouch: 'تواصل معنا',
      sendMessage: 'أرسل لنا رسالة',
      openForm: 'فتح نموذج الاتصال',
      followYoutube: 'تابعنا على يوتيوب',
      followInstagram: 'تابعنا على انستغرام',
      followTiktok: 'تابعنا على تيك توك',
      followTwitter: 'تابعنا على X (تويتر)'
    },
    inquiry: {
      title: 'إرسال استفسار',
      namePlaceholder: 'اسمك *',
      emailPlaceholder: 'بريدك الإلكتروني *',
      phonePlaceholder: 'رقم الهاتف',
      messagePlaceholder: 'رسالتك *',
      arrivalFlight: 'رقم رحلة الوصول *',
      departureFlight: 'رقم رحلة المغادرة *',
      plannedDate: 'تاريخ الجولة المخطط *',
      specialRequirements: 'متطلبات خاصة ومعلومات إضافية عن المسافرين',
      flightDetails: 'تفاصيل الرحلة والجولة',
      priceQuote: 'سنتواصل معك في أقرب وقت مع أفضل عرض سعر.',
      submit: 'إرسال الاستفسار',
      bookCall: 'حجز موعد',
      submitting: 'جاري الإرسال...',
      inquirySuccess: 'تم إرسال الاستفسار بنجاح!',
      inquiryError: 'خطأ في إرسال الاستفسار.',
      interestedIn: 'أنا مهتم بـ'
    },
    footer: {
      rights: '© 2026 Viaturkey للاستثمارات والسياحة. جميع الحقوق محفوظة.',
      tagline: 'شريكك الموثوق في تركيا'
    },
    tripadvisor: {
      title: 'موصى به من ضيوف TripAdvisor',
      linkText: 'شاهد تقييماتنا',
      text: 'نحن نفتخر بتقييماتنا الممتازة على TripAdvisor',
      seeReviews: 'شاهد التقييمات'
    },
    blog: {
      heroTitle: 'مدونة السفر إلى إسطنبول',
      heroSubtitle: 'أدلة متخصصة ونصائح سفر ومعرفة داخلية لرحلتك إلى إسطنبول',
      allCategory: 'الكل',
      cityTours: 'جولات المدينة',
      shoreExcursions: 'الرحلات الشاطئية',
      foodCulture: 'الطعام والثقافة',
      travelTips: 'نصائح السفر',
      turkishCitizenship: 'الجنسية التركية',
      readMore: 'اقرأ المزيد',
      backToBlog: 'العودة إلى المدونة',
      posts: [
        { title: 'الدليل الشامل للرحلة الشاطئية في إسطنبول من غالاتابورت', excerpt: 'كل ما تحتاج معرفته لتخطيط الرحلة الشاطئية المثالية من محطة غالاتابورت للسفن السياحية في إسطنبول.', readTime: '8 دقائق قراءة' },
        { title: 'أفضل جولة طعام في إسطنبول: رحلة طهي عبر المدينة', excerpt: 'اكتشف مشهد الطعام النابض بالحياة في إسطنبول من كباب الشارع إلى مطبخ القصر العثماني مع مرشدينا المحليين.', readTime: '6 دقائق قراءة' },
        { title: 'الجنسية التركية عبر الاستثمار: دليل 2026 الكامل', excerpt: 'دليل خطوة بخطوة للحصول على الجنسية التركية من خلال الاستثمار العقاري. المتطلبات والعملية والجدول الزمني.', readTime: '10 دقائق قراءة' },
        { title: 'برنامج جولة إسطنبول المثالي: المدينة القديمة في يوم واحد', excerpt: 'كيف تزور آيا صوفيا والمسجد الأزرق وقصر توبكابي والبازار الكبير في جولة واحدة.', readTime: '7 دقائق قراءة' },
        { title: '15 نصيحة أساسية للزائرين الجدد لإسطنبول', excerpt: 'من صرف العملات إلى النقل، كل ما يحتاج الزائر لأول مرة معرفته قبل الوصول إلى إسطنبول.', readTime: '5 دقائق قراءة' },
        { title: 'قناة إسطنبول: لماذا يشتري المستثمرون الأذكياء الآن', excerpt: 'مشروع القناة الضخم يعيد تشكيل الجانب الأوروبي لإسطنبول. لماذا العقارات على طول الممر في ازدهار.', readTime: '9 دقائق قراءة' }
      ],
      shore: {
        byLine: 'فريق Viaturkey',
        intro: 'إذا كنت تصل إلى إسطنبول على متن سفينة سياحية، فأنت ترسو في واحد من أكثر محطات الرحلات البحرية إثارة في العالم — غالاتابورت. يقع في قلب حي كاراكوي، ويضعك غالاتابورت في متناول أعظم معالم إسطنبول. لكن مع الوقت المحدود في الميناء، فإن التخطيط لرحلة شاطئية فعالة أمر ضروري.',
        intro2: 'في Viaturkey، نقود ركاب السفن السياحية عبر إسطنبول منذ سنوات. إليك كل ما تحتاج معرفته لتحقيق أقصى استفادة من وقتك على الشاطئ.',
        h2_galataport: 'ما هو غالاتابورت ولماذا هو مهم؟',
        p_galataport1: 'غلطة بورت هي محطة السفن السياحية الحديثة في إسطنبول على الجانب الأوروبي من البوسفور، وقد استقبلت أول سفينة سياحية عام 2021. على عكس المحطة القديمة، يقع غالاتابورت في الوسط — على بُعد دقائق من ميدان تقسيم وبازار التوابل وحي السلطان أحمد التاريخي.',
        p_galataport2: 'بالنسبة لركاب السفن السياحية، هذا يغير قواعد اللعبة. يمكن للرحلة الشاطئية الخاصة من غالاتابورت تغطية المزيد في وقت أقل.',
        h2_itinerary: 'أفضل برنامج: رحلة شاطئية في 6-8 ساعات',
        p_itinerary: 'إليك البرنامج الذي يوصي به مرشدونا المرخصون للزوار لأول مرة مع 6-8 ساعات في الميناء:',
        stops: ['آيا صوفيا — التحفة المعمارية التي يبلغ عمرها 1500 عام. كانت كنيسة ثم مسجداً ثم عادت مسجداً. مع مرشد خاص، نتولّى التذاكر والتوقيت ونختار أوقات الدخول الأقل ازدحاماً، وتحصلون على فهم عميق لتاريخها.', 'المسجد الأزرق (السلطان أحمد) — أشهر مساجد إسطنبول بمآذنه الست وقبابه المتدرجة.', 'قصر توبكابي — مقر إقامة السلاطين العثمانيين لمدة 400 عام. قسم الحريم والخزانة لا بد من زيارتهما.', 'البازار الكبير — واحد من أقدم وأكبر الأسواق المسقوفة في العالم مع أكثر من 4000 متجر.', 'بازار التوابل — متعة حسية من الحلوى التركية والزعفران والفواكه المجففة والشاي الحرفي.'],
        h2_why: 'لماذا تحجز جولة خاصة بدلاً من رحلات السفينة؟',
        p_why: 'رحلات السفينة مريحة لكنها تأتي بعيوب: مجموعات كبيرة (30-50 شخصاً)، جداول صارمة، وأسعار أعلى بنسبة 25-40٪. إليك لماذا الجولة الخاصة مع Viaturkey هي الخيار الأفضل:',
        reasons: ['وتيرة شخصية — أنت تحدد البرنامج', 'مرشد محلي مرخص — جميع مرشدينا حاصلون على ترخيص حكومي', 'خدمة من الباب إلى الباب — نستقبلك في غالاتابورت ونعيدك إلى سفينتك', 'وفّر 25٪+ — حجز مباشر بدون رسوم وسيط', 'ضمان العودة للسفينة — نراقب جدول سفينتك ونضمن عودتك في الوقت المحدد'],
        h2_food: 'محطات الطعام خلال رحلتك الشاطئية',
        p_food: 'لا تكتمل زيارة إسطنبول بدون تذوق المطبخ المحلي. نضمّن محطات في أفضل المطاعم المحلية:',
        foodStops: ['فطور تركي أصيل مع السميت والجبن والزيتون والشاي الطازج', 'كباب إسطنبول الشهير في مطعم عائلي بالقرب من البازار الكبير', 'تذوق البقلاوة في محل حلويات عمره قرن من الزمان', 'عصير رمان طازج من بائع متجول'],
        foodLink: 'باقات جولة الطعام في إسطنبول',
        h2_know: 'ما يجب معرفته قبل رحلتك الشاطئية',
        knowItems: ['العملة: الليرة التركية (TL). معظم المواقع السياحية تقبل البطاقات، لكن احمل نقوداً للبازارات.', 'قواعد اللباس: المساجد تتطلب تغطية الأكتاف والركب. أغطية الرأس متوفرة عند المدخل.', 'أفضل الأشهر: أبريل-يونيو وسبتمبر-نوفمبر للطقس المعتدل وعدد أقل من السياح.', 'اللغات: مرشدونا يتحدثون الإنجليزية والروسية والعربية والتركية.'],
        h2_faq: 'الأسئلة المتكررة',
        faqs: [
          { q: 'كم تستغرق الرحلة الشاطئية من غالاتابورت؟', a: 'معظم الرحلات تستغرق 6-8 ساعات، وهي كافية لتغطية جميع المعالم الرئيسية. نخصص البرنامج وفقاً لجدول سفينتك.' },
          { q: 'هل يمكنكم ضمان العودة للسفينة في الوقت المحدد؟', a: 'بالتأكيد. نراقب جدول مغادرة سفينتك. على مدار سنوات من الخدمة، لم يفوت أي ضيف سفينته أبداً.' },
          { q: 'هل تقدمون جولات بلغات أخرى غير الإنجليزية؟', a: 'نعم. مرشدونا المرخصون يقدمون جولات بالإنجليزية والروسية والعربية والتركية.' },
          { q: 'كم تكلف الرحلة الشاطئية الخاصة؟', a: 'تعتمد الأسعار على حجم المجموعة والبرنامج. تواصل معنا على واتساب — عادةً أقل بنسبة 25٪ من رحلات السفينة.' }
        ],
        ctaTitle: 'مستعد لحجز رحلتك الشاطئية في إسطنبول؟',
        ctaText: 'راسلنا مباشرة على واتساب للحصول على برنامج مخصص وعرض سعر فوري. بدون وسيط، بدون رسوم مخفية.',
        ctaBtn: 'راسلنا على واتساب'
      }
    },
    newProject: {
      badge: 'مشروع جديد',
      title: 'مساكن المترو في وسط إسطنبول 2026 — البيع مفتوح الآن',
      subtitle: 'شقق فاخرة على محور باسن إكسبرس في إسطنبول · من 259,000 دولار · مؤهل للجنسية التركية (بحد أدنى 400,000 دولار استثمار إجمالي)',
      cta: 'اكتشف المشروع'
    },
    seo: {
      homeTitle: 'جولات إسطنبول والعقارات | Viaturkey',
      homeDesc: 'شريككم الموثوق في إسطنبول: جولات خاصة بمرشد مرخص، استشارات عقارية فاخرة، والجنسية التركية عبر الاستثمار — خدمة كاملة باللغة العربية.',
      travelTitle: 'جولات إسطنبول الخاصة مع مرشد مرخص | Viaturkey',
      travelDesc: 'خطط جولات خاصة في إسطنبول مع مرشدين مرخصين يتحدثون العربية: رحلات شاطئية من غالاتابورت، رحلات البوسفور، جولات الطعام وجولات الترانزيت من المطار.',
      realEstateTitle: 'عقارات إسطنبول والجنسية التركية عبر الاستثمار | Viaturkey',
      realEstateDesc: 'تملّك عقاراً فاخراً في إسطنبول واحصل على الجنسية التركية. استشارات عقارية متكاملة لمواطني الخليج — من اختيار العقار حتى استلام الجواز التركي.',
      blogTitle: 'مدونة السفر إلى إسطنبول | Viaturkey',
      blogDesc: 'أدلة سفر متخصصة عن إسطنبول: نصائح الجولات الخاصة، تخطيط الرحلات الشاطئية من غالاتابورت، والاستثمار والجنسية التركية للمسافرين الخليجيين.',
      blogH1: 'مدونة السفر إلى إسطنبول',
      blogSub: 'أدلة متخصصة ونصائح سفر ومعرفة محلية لرحلتكم إلى إسطنبول',
      readMore: 'اقرأ المزيد',
      faqTitle: 'الأسئلة الشائعة عن جولات إسطنبول | Viaturkey',
      faqDesc: 'إجابات عن الأسئلة الشائعة حول جولات إسطنبول الخاصة، الرحلات الشاطئية من غالاتابورت، رحلات البوسفور، الجنسية التركية والاستثمار العقاري.'
    }
  };

